"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetInspectionsResponseDto = instanceOfGetInspectionsResponseDto;
exports.GetInspectionsResponseDtoFromJSON = GetInspectionsResponseDtoFromJSON;
exports.GetInspectionsResponseDtoFromJSONTyped = GetInspectionsResponseDtoFromJSONTyped;
exports.GetInspectionsResponseDtoToJSON = GetInspectionsResponseDtoToJSON;
exports.GetInspectionsResponseDtoToJSONTyped = GetInspectionsResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var InspectionItemDto_1 = require("./InspectionItemDto");
/**
 * Check if a given object implements the GetInspectionsResponseDto interface.
 */
function instanceOfGetInspectionsResponseDto(value) {
    if (!('inspections' in value) || value['inspections'] === undefined)
        return false;
    return true;
}
function GetInspectionsResponseDtoFromJSON(json) {
    return GetInspectionsResponseDtoFromJSONTyped(json, false);
}
function GetInspectionsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
        'inspections': (json['inspections'].map(InspectionItemDto_1.InspectionItemDtoFromJSON)),
    };
}
function GetInspectionsResponseDtoToJSON(json) {
    return GetInspectionsResponseDtoToJSONTyped(json, false);
}
function GetInspectionsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
        'inspections': (value['inspections'].map(InspectionItemDto_1.InspectionItemDtoToJSON)),
    };
}
